import React, { useEffect, useState } from "react";
import { MODEL } from "../../../model";

const BlogBannerSection = () => {
  const [bannerImages, setBannerImages] = useState([]);

  useEffect(() => {
    const blogBannerImages = getRandomFourImages(MODEL.data.blogs);
    setBannerImages(blogBannerImages);
  }, []);

  function getRandomFourImages(arr) {
    // Return empty array if arr is not a valid non-empty array
    if (!Array.isArray(arr) || arr.length === 0) return [];

    // If 4 or fewer items exist, work with a copy of the entire array
    let items = arr.length <= 4 ? arr.slice() : arr.slice();

    // If more than 4, shuffle the array using Fisher-Yates algorithm and then take first 4
    if (arr.length > 4) {
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      items = items.slice(0, 4);
    }

    // Extract and return the image property from each blog object.
    // Assumes each blog object contains an image object (with id, title, image URL, etc.)
    return items.map((item) => item.image);
  }

  console.log({ bannerImages });

  return (
    <section className="blog_heroSection">
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="true"
      >
        <div className="carousel-indicators">
          {bannerImages &&
            // Reverse for indicators if needed; adjust as desired
            bannerImages
              .slice()
              .reverse()
              .map((v, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to={index}
                  className={index === 0 ? "active" : ""}
                  aria-current={index === 0 ? "true" : undefined}
                  aria-label={v.alt}
                ></button>
              ))}
        </div>
        <div className="carousel-inner banner-blog">
          {bannerImages &&
            bannerImages.map((v, index) => (
              <div
                key={index}
                className={`carousel-item c-image ${
                  index === 0 ? "active" : ""
                }`}
              >
                <img
                  width={100}
                  height={100}
                  loading="lazy"
                  src={v.src.startsWith("https") ? `${v.src}` : `/${v.src}`} // image URL
                  className="d-block"
                  alt={v.alt}
                  title={v.alt}
                />
              </div>
            ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default BlogBannerSection;
